import { z } from 'zod';

export const PREPAID_STATEMENTS_MAX_MONTHS = 12;

export const PrepaidStatementsSettings = z.object({
  enabled: z.boolean(),
  maxMonths: z.number().int().min(1).max(PREPAID_STATEMENTS_MAX_MONTHS),
});
export type PrepaidStatementsSettings = z.infer<typeof PrepaidStatementsSettings>;

export const DEFAULT_PREPAID_STATEMENTS_SETTINGS: PrepaidStatementsSettings = {
  enabled: false,
  maxMonths: 6,
};
